import { createSlice } from "@reduxjs/toolkit";

const passwordSLice = createSlice({
    name:"password",
    initialState:{
        isError: false,
     
    }, 

    reducers:{
        setError(state){
            state.isError = true;
        },
   


    }
});


const passwordReducer = passwordSLice.reducer;
const passwordActions = passwordSLice.actions;

export {passwordActions , passwordReducer}